import Event from "common/event";
import { ActionWithDispatch } from "common/actionWithDispatch";
import PageFilter from "./pageFilter";
import pageFilterService from "./pageFilter.service";

export class PageFilterLoaded extends Event {
  constructor(public pageFilter: PageFilter) {
    super(PageFilterLoaded.EventName);
  }

  public static EventName: string = "PAGE_FILTER_LOADED";
}

export class PageFilterUpdated extends Event {
  constructor(public pageFilter: PageFilter) {
    super(PageFilterUpdated.EventName);
  }

  public static EventName: string = "PAGE_FILTER_UPDATED";
}

export function loadPageFilter(pageName?: string): ActionWithDispatch<PageFilter> {
  return function (dispatch: any) {
    return pageFilterService
      .getPageFilter(pageName)
      .then(filter => dispatch(new PageFilterLoaded(filter ?? new PageFilter()).toObject()));
  };
}

export function updatePageFilter(pageFilter: PageFilter, pageName?: string): ActionWithDispatch<any> {
  return async function(dispatch: any) {
     pageFilterService.updatePageFilter(pageFilter, pageName);
     dispatch(new PageFilterUpdated(pageFilter).toObject());
  }
}